module.exports = __webpack_public_path__ + "img/bg81.4020448f.jpg";